import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnDestroy,
    ViewChild,
    ViewEncapsulation
} from "@angular/core";
import {FormControl} from "@angular/forms";
import {Base} from "../../../../../../../../common/interfaces/base.interfaces";
import {AbstractWizardStepComponent, Wizard} from "../../../../../../../../common/interfaces/wizard.interface";
import {User} from "../../../../../../../../common/interfaces/user.interface";
import {Api, ApiService} from "../../../../../../../../common/services/api.service";
import {ToastService} from "../../../../../../../../common/services/toast.service";
import {Modal, ModalService} from "../../../../../../../services/modal.service";
import {Warehouse} from "../../../../../../../../common/interfaces/warehouse.interface";
import {HelpersService} from "../../../../../../../../common/services/helpers.service";
import {
    BoxItemsListComponent,
    PalletItemsListComponent,
    WarehouseProceduresWizardSelectOrderItemModalComponent
} from "../../..";
import {SpinnerService} from "../../../../../../../../common/services/spinner.service";
import {PusherService} from "../../../../../../../../common/services/pusher.service";
import {PackageFormComponent} from "../../../../package";
import {SoundsService} from "../../../../../../../../common/services/sounds.service";
import {Api3Service} from "../../../../../../../../common/services/api3.service";
import {BoxStickerComponent} from "../../../../boxes";
import {ConfirmComponent} from "../../../../../../../../common/components/confirm/confirm.component";
import {WarehouseBufferScanFormComponent} from "../../common/buffer-scan/form.component";
import {ModalTableComponent} from "../../../../../../../../common/components/modal/modal-table.component";
import {takeUntil} from "rxjs";
import {OrderItemStickerComponent}
    from "src/modules/section/components/partner/components/order/item/sticker/sticker.component";


export interface IOutboundOrderLocation {
    matched: boolean;
    location: { id: number; location: string; warehouse_location_type_id: number };
    pallets: any[];
    boxes: any[];
    items: any[];
}

@Component({
    selector: "section-warehouse-procedures-wizard-outbound-scan",
    templateUrl: "scan.component.html",
    styleUrls: [
        "scan.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class WarehouseProceduresWizardOutboundScanComponent extends AbstractWizardStepComponent
    implements OnDestroy {

    private state: Base.IState;

    private warehouse_slug: string;

    private prevKey: string = null;

    public originalItemsData: any = null;

    public procedureType: string = null;

    public shipment: Warehouse.IShipment;

    @ViewChild("searchInputRef", {static: false})
    public searchInputRef: ElementRef;

    @ViewChild(ConfirmComponent, {static: false})
    public confirm: ConfirmComponent;

    public scannerKey: string;

    public partner: User.IPartner;

    public warehouse: Warehouse.IWarehouse;

    public searchInput: FormControl = new FormControl(null);

    public searchInputLabel: string = "Item, serial, box, pallet/ob";

    public selectedPackage: FormControl = new FormControl(null);

    public packages: any[] = [];

    public orderRef: string;

    public scannerOnly: boolean = false;

    public isViewOnly: boolean = false;

    public scanFeed: any[] = [];

    public checkedFeedItems: string[] = [];

    public locations: IOutboundOrderLocation[] = [];

    public outboundItemsSearch: FormControl = new FormControl(null);

    public showMatchedInList: FormControl = new FormControl(false);

    public showOnlyFailedScans: FormControl = new FormControl(false);

    public selectAll: FormControl = new FormControl(false);

    public totalToScan: any = {
        pallets: 0,
        boxes: 0,
        items: 0
    };

    public totalScanned: any = {
        pallets: 0,
        boxes: 0,
        items: 0
    };

    public joined_orders: { [key: number]: string } = null;

    public constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        private apiService: ApiService,
        private api3Service: Api3Service,
        private toastService: ToastService,
        private modalService: ModalService,
        public soundsService: SoundsService,
        private spinnerService: SpinnerService,
        private pusherService: PusherService,
    ) {
        super(changeDetectorRef);
    }


    private connectToSockets(): void {

        if (!this.shipment) {
            return;
        }

        let t1: any;

        this.pusherService.echo.private("scan-feed-" + this.shipment.id)
            .listen(".App\\Events\\WarehouseBufferScanEvent", (data: any): void => {
                console.warn("WarehouseBufferScanEvent", data);

                let update = false;
                for (const index in this.scanFeed) {
                    if (data.feed_id === this.scanFeed[index].feed_id) {
                        this.scanFeed[index] = data.data;
                        update = true;
                        break;
                    }
                }

                if (!update) {
                    this.addScan(data.data);
                }

                this.changeDetectorRef.markForCheck();

                if (t1) {
                    clearTimeout(t1);
                }

                t1 = setTimeout(() => {
                    this.getScanBuffer();
                    this.getItems();
                    this.getPackages();
                }, 2000);
            });
    }

    private async getScanBuffer(): Promise<any> {
        const {data}: Api.IResponse = await this.api3Service.request(Api.EMethod.Get,
            `${this.state.section}/scan/outbound/${this.shipment.id}`, {}, {});

        if (data) {
            this.scanFeed = data;
            this.changeDetectorRef.markForCheck();
            if (this.originalItemsData) {
                this.mapData(this.originalItemsData);
            }
            this.setFocus();
        }
    }

    private addScan(data: any): void {

        var newArray = this.scanFeed.slice();
        newArray.unshift(data);

        this.scanFeed = newArray;

        this.changeDetectorRef.markForCheck();
    }

    /**
     * Get package list
     */
    private async getPackages(): Promise<any> {
        this.spinnerService.show();
        const {data}: Api.IResponse = await this.api3Service.get(
            `${this.state.section}/shipments/${this.shipment.id}/packages`, {
                relations: [
                    "Shipment:id,order_id",
                    "WarehousePackageType:id,name"
                ]
            });
        this.spinnerService.hide();
        if (data) {
            this.packages = data;
            if (this.packages.length === 0) {
                this.newPackadge();
                this.soundsService.textToSpeech("Please create package");
            } else if (!this.selectedPackage.value) {
                this.selectedPackage.setValue(this.packages[0].id);
            }
            this.changeDetectorRef.markForCheck();
        }
    }

    /**
     * Get shipment
     */
    private async getShipment(): Promise<any> {
        this.spinnerService.show();
        const {data}: Api.IResponse = await this.api3Service.request(Api.EMethod.Get,
            `${this.state.section}/shipments/${this.shipment.id}`, {}, {
                relations: [
                    "Partner",
                    "Order:id,service_level_id,ref",
                    "Warehouse",
                    "JoinedShipments:id,parent_id,order_id",
                    "JoinedShipments.Order:id,ref",
                ]
            });

        if (data) {
            this.shipment = data;
            this.scannerOnly = this.shipment && this.shipment.partner
                ? this.shipment.partner.properties.disable_manual_scanning
                : false;

            this.joined_orders = {
                [this.shipment.order_id]: this.shipment.order.ref
            };

            if (this.shipment.joined_shipments.length > 0) {


                for (const shipment of this.shipment.joined_shipments) {
                    this.joined_orders[shipment.order_id] = shipment.order.ref;
                }

                this.result.emit({
                    action: "result",
                    value: {
                        joined_orders: Object.values(this.joined_orders)
                            .filter(o => o !== this.shipment.order.ref)
                            .join(", ")
                    }
                });
            }


            this.changeDetectorRef.markForCheck();

            this.connectToSockets();
        }
        this.spinnerService.hide();
    }

    private async getItems(): Promise<any> {
        this.spinnerService.show();
        const {code, message, data}: Api.IResponse = await this.api3Service.request(Api.EMethod.Get,
            `${this.state.section}/scan/outbound/${this.shipment.id}/items`);
        this.spinnerService.hide();

        if (code === 210) {

            this.toastService.show({
                message,
                url: [
                    this.state.section,
                    "procedures-outbound",
                    "wizard",
                    "order",
                    data.warehouse_order_id,
                    "order_ref",
                    data.order_ref,
                    "order_id",
                    data.order_id
                ],
                url_button: true,
                url_button_text: "Open parent order",
                duration: 30000,
            }, "warning");

        } else if (data) {
            this.originalItemsData = data;
            this.mapData(this.originalItemsData);
            this.setFocus();
        }
    }

    private async getWarehouse(): Promise<any> {
        this.spinnerService.show();
        const {data}: Api.IResponse = await this.apiService.request(Api.EMethod.Get,
            ["warehouse", "findBySlug", this.warehouse_slug]);
        if (data) {
            this.warehouse = data;
            this.showMatchedInList.setValue(
                this.warehouse.properties.default_show_fully_scanned_items ?? false
            );
        }
        this.spinnerService.hide();
    }

    private mapData(data: { pallets: any[], boxes: any[], items: any [] }): void {
        this.locations = [];

        this.totalToScan = {
            pallets: 0,
            boxes: 0,
            items: 0
        };

        const locations: any = {};

        this.totalToScan.pallets = data.pallets.length;

        for (let pallet of data.pallets) {
            pallet = {...pallet};

            pallet.matched = false;

            const location_id = pallet.warehouse_location?.id;

            if (!locations[location_id]) {
                locations[location_id] = {
                    pallets: [pallet],
                    boxes: [],
                    items: [],
                    location: pallet.warehouse_location,
                    matched: true,
                };
            } else {
                locations[location_id].pallets.push(pallet);
            }
        }

        this.totalToScan.boxes = data.boxes.length;

        for (let box of data.boxes) {
            box = {...box};

            box.matched = false;

            const location_id = box.warehouse_location?.id;

            if (!locations[location_id]) {
                locations[location_id] = {
                    pallets: [],
                    boxes: [box],
                    items: [],
                    location: box.warehouse_location,
                    matched: true,
                };
            } else {
                locations[location_id].boxes.push(box);
            }
        }

        for (let item of data.items) {
            item = {...item};

            item.matched = false;
            item.matched_qty = 0;
            this.totalToScan.items += item.quantity;

            const location_id = item.warehouse_location?.id;

            if (!locations[location_id]) {
                locations[location_id] = {
                    pallets: [],
                    boxes: [],
                    items: [item],
                    location: item.warehouse_location,
                    matched: true,
                };
            } else {
                locations[location_id].items.push(item);
            }
        }

        this.locations = Object.values(locations);

        this.changeDetectorRef.markForCheck();

        this.checkMatchingScans();
    }

    private checkMatchingScans(): void {

        if (!Object.keys(this.locations).length || !this.scanFeed) {
            return;
        }

        for (const location of this.locations) {
            this.matchPalletScans(this.scanFeed, location.pallets);
            this.matchBoxScans(this.scanFeed, location.boxes);
            this.matchSerialScans(this.scanFeed, location.items);
            this.matchItemScans(this.scanFeed, location.items);
        }

        for (const location of this.locations) {

            for (const pallet of location.pallets) {
                if (!pallet.matched) {
                    location.matched = false;
                } else {
                    this.totalScanned.pallets++;
                }
            }

            for (const box of location.boxes) {
                if (!box.matched) {
                    location.matched = false;
                } else {
                    this.totalScanned.boxes++;
                }
            }

            for (const item of location.items) {
                if (item.matched_qty === item.quantity) {
                    item.matched = true;
                    this.totalScanned.items++;
                } else {
                    location.matched = false;
                }

            }
        }

        this.countScansTotal();
    }

    private countScansTotal(): void {

        this.totalScanned = {
            pallets: 0,
            boxes: 0,
            items: 0
        };

        for (const scan of this.scanFeed) {
            if (scan.status !== "success") {
                continue;
            }

            if (scan.type === "pallet") {
                this.totalScanned.pallets++;
            }

            if (scan.type === "box") {
                this.totalScanned.boxes++;
            }

            if (scan.type === "serial") {
                this.totalScanned.items++;
            }

            if (scan.type === "item") {
                this.totalScanned.items += scan.quantity;
            }
        }

        this.changeDetectorRef.markForCheck();
    }

    private matchPalletScans(scans, pallets): void {
        scanLoop: for (const scan of scans) {
            if (scan.status !== "success" || scan.type !== "pallet") {
                continue;
            }
            for (const pallet of pallets) {
                if (pallet.id === scan.pallet_id) {
                    pallet.matched = true;
                    scan.matched = true;
                    continue scanLoop;
                }
            }
        }
    }

    private matchBoxScans(scans, boxes): void {
        scanLoop: for (const scan of scans) {
            if (scan.status !== "success" || scan.type !== "box") {
                continue;
            }
            for (const box of boxes) {
                if (box.id === scan.box_id) {
                    box.matched = true;
                    scan.matched = true;
                    continue scanLoop;
                }
            }
        }
    }

    private matchSerialScans(scans, items): void {
        scanLoop: for (const scan of scans) {
            if (scan.status !== "success" || !scan.serial) {
                continue;
            }

            for (const item of items) {
                if (!item.serial) {
                    continue;
                }
                if (item.serial === scan.serial) {
                    item.matched_qty = 1;
                    scan.matched = true;
                    continue scanLoop;
                }
            }
        }
    }

    private matchItemScans(scans, items): void {

        for (const item of items) {
            const ids = item.ids.split(",");

            for (const scan of scans) {
                if (scan.status !== "success" || scan.type !== "item" || scan.matched) {
                    continue;
                }

                for (const allocation of scan.allocations) {
                    if (ids.includes("" + allocation.allocation_id)) {
                        item.matched_qty += allocation.quantity;
                    }
                }
            }
        }
    }

    private outboundByOrderItem(
        allocations: Warehouse.IInventoryAllocation[],
        feed_id: string,
        serial_fill: string = null
    ): void {

        const grouped_items: any = [];

        allocations_loop: for (const allocation of allocations) {

            const key = allocation.order_id
                + "-" + allocation.item
                + "-" + allocation.warehouse_location_id
                + "-" + allocation.batch
                + "-" + allocation.rev
                + "-" + allocation.lot;

            let serial_required = allocation.part_master.required_serial_wh_outbound;

            if (this.shipment.order.service_level_id == 200
                && this.shipment.partner_id == 31
                && allocation.item.startsWith("SIMC")
            ) {
                serial_required = false; //ISSUE-6543
            }

            if (serial_fill && allocation.serial && serial_fill !== allocation.serial) {
                continue;
            }

            const serials: string[] = allocation.serial ? [allocation.serial] : [];

            for (const location of this.locations) {
                for (const pallet of location.pallets) {
                    if (pallet.id === allocation.pallet_id && pallet.matched) {
                        continue allocations_loop;
                    }
                }
                for (const box of location.boxes) {
                    if (box.id === allocation.box_id && box.matched) {
                        continue allocations_loop;
                    }
                }
                for (const item of location.items) {
                    if (item.id === allocation.id) {
                        allocation.quantity -= item.matched_qty;
                    }
                }
            }

            if (allocation.quantity <= 0) {
                continue;
            }

            const in_group_item = grouped_items.find(item => item.id === key);
            if (in_group_item) {
                in_group_item.quantity += allocation.quantity;
                if (allocation.serial) {
                    in_group_item.serials = [];
                    in_group_item.serial = null;
                }
                continue;
            }


            grouped_items.push({
                id: key,
                part_master_id: allocation.part_master_id,
                item: allocation.item,
                has_serial: allocation.part_master.serial,
                serial_required,
                serial: serials.length == 1 ? serials[0] : null,
                serials,
                has_batch: allocation.part_master.batch,
                batch_required: allocation.part_master.required_batch_outbound,
                batch: allocation.batch,
                has_revision: allocation.part_master.revision,
                revision_required: allocation.part_master.required_revision_outbound,
                rev: allocation.rev,
                has_lot: allocation.part_master.lot,
                lot_required: allocation.part_master.required_lot_outbound,
                lot: allocation.lot,
                warehouse_location: {
                    location: allocation.warehouse_location?.location,
                    id: allocation.warehouse_location?.id
                },
                location_id: allocation.warehouse_location_id,
                partner_id: allocation.partner_id,
                partner: allocation.partner,
                quantity: allocation.quantity,
                order_id: allocation.order_id,
                order_ref: allocation.order?.ref,
                type: "outbound",
                shipment_id: allocation.order_item.parcel.shipment_id,
                warehouse_order_id: allocation.order_item.parcel.shipment.warehouse_order.id,
                package_id: this.selectedPackage.value,
                feed_id,
            });
        }

        const items: any[] = grouped_items;

        if (items.length === 1) {
            const item: any = items[0];
            this.addTransactionFromItem(item);
        } else if (items.length > 1) {
            this.selectOrderItems(items, items[0].partner);
        } else {
            const message: string = "Item not found or must be scanned as a box or pallet";
            this.soundsService.textToSpeech(message);
            this.toastService.show(message, "warning");
        }
    }

    private async addTransactionFromItem(item: any): Promise<any> {

        const response: Modal.IResponse = await this.modalService.open(WarehouseBufferScanFormComponent,
            {
                data: item,
                modalWidth: 600,
                modalHeight: 500,
                type: "outbound",
                state: this.state,
                scannerKey: this.scannerKey,
                partner: item.partner,
                warehouse_slug: this.warehouse_slug,
                location_name: item.warehouse_location.location
            });

        if (response && response.value) {

            this.addScan({
                feed_id: item.feed_id,
                item: item.item,
                status: "pending",
                quantity: response.value.quantity,
                type: "item"
            });

            for (const location of this.locations) {
                for (const item of location.items) {
                    if (item.order_item_id === response.value.order_item_id) {
                        item.quantity -= response.value.quantity;
                    }
                }
            }

            // this.getScanBuffer();

            this.toastService.show("Item scanned", "success");
            this.soundsService.textToSpeech("Item scanned");
        }

        this.searchInput.reset();
        this.setFocus();
    }

    private setFocus(): void {
        setTimeout(() => {
            if (this.searchInputRef) {
                this.searchInputRef.nativeElement.focus();
            }
        }, 1000);
    }

    private async selectOrderItems(items: any[], partner: User.IPartner): Promise<any> {
        const response: Modal.IResponse = await this.modalService
            .open(WarehouseProceduresWizardSelectOrderItemModalComponent, {
                items,
                partner,
                type: "outbound"
            });
        if (response && response.value) {
            const item: any = response.value;
            this.addTransactionFromItem(item);
        }
    }

    private async exportBoxPackList(type: string): Promise<any> {
        this.spinnerService.show();
        const {data, message}: Api.IResponse = await this.apiService.request(Api.EMethod.Get,
            ["warehouse_location", "shipment", "" + this.shipment.id], {}, {
                export: type
            });
        if (data && data.length) {
            window.open(data[0], "_blank");
        }

        if (message) {
            this.toastService.show(message, "success");
        }
        this.spinnerService.hide();
    }

    private async exportUniversalPackList(type: string): Promise<any> {
        this.spinnerService.show();
        const {code, message}: Api.IResponse = await this.apiService.request(Api.EMethod.Get,
            ["inventory_allocation", "by_shipment", "" + this.shipment.id], {}, {
                export: type
            });

        this.spinnerService.hide();

        if (code === 200) {
            this.toastService.show(message, "success");
        }
    }

    public selectPackage(id: number): void {
        this.selectedPackage.setValue(id);
        this.changeDetectorRef.markForCheck();
        this.soundsService.textToSpeech("Package selected");
        this.toastService.show("Package selected: " + this.selectedPackageName(id), "success");
    }

    public selectedPackageName(id: number): string {
        const selected: any = this.packages.find((pack: { id: number }) => {
            return pack.id === id;
        });
        if (selected) {
            return `${selected.name} (${selected.warehouse_package_type?.name}) `;
        }
        return "";
    };

    /**
     * Show items in the box
     * @param box
     */
    public async openBox(box: any): Promise<any> {
        const response: Modal.IResponse = await this.modalService.open(BoxItemsListComponent,
            {
                box,
                modalWidth: 1000,
                itemsType: "allocations"
            });
    }

    public async openPallet(pallet: any): Promise<any> {
        const response: Modal.IResponse = await this.modalService.open(PalletItemsListComponent,
            {
                pallet,
                modalWidth: 1000,
                itemsType: "boxes"
            });
    }

    /**
     * Print box sticker
     * @param box
     */
    public async printBoxSticker(box: any): Promise<any> {
        const response: Modal.IResponse = await this.modalService.open(BoxStickerComponent, {
            box,
            orderRef: this.orderRef
        });
    }

    public async showAllocations(allocations: any[]): Promise<any> {
        const response: Modal.IResponse = await this.modalService.open(ModalTableComponent,
            {
                title: "Item allocations",
                table: {
                    table_id: "sadzf7sygw4v",
                    columns: [
                        {
                            data: "item",
                            title: "Item",
                            sortable: false
                        },
                        {
                            data: "batch",
                            title: "Batch",
                            sortable: false
                        },
                        {
                            data: "serial",
                            title: "Serial",
                            sortable: false
                        },
                        {
                            data: "configurations",
                            title: "Configurations",
                            sortable: false
                        },
                        {
                            data: "quantity",
                            title: "Quantity",
                            sortable: false
                        },
                        {
                            data: "box.ref",
                            title: "Box",
                            sortable: false
                        },
                    ],
                    table_data: allocations
                }
            });
    }

    /**
     * Listen scanner activation key event
     * @param event
     */
    public onKeydown(event: any): void {
        if (this.prevKey !== "Control" && this.prevKey !== "Shift") {
            if (event.key === "Enter" || event.key === "Tab") {
                this.find();
            }
        }

        if ((this.prevKey === "Control" || this.prevKey === "Shift" || this.prevKey === "Alt")
            && event.key === "Enter") {
            this.searchInput.setValue(this.searchInput.value + ",");
        }

        this.prevKey = event.key;
    }

    private clearValue(original: string): string {
        return original.trim().replace(/^_+|_+$/g, "");
    }

    /**
     * Find box
     */
    public async find(): Promise<any> {

        const value = this.clearValue(this.searchInput.value);
        if (!value) {
            this.toastService.show("Empty value scanned", "warning");
            return;
        }

        this.spinnerService.show();

        const feed_id: string = this.shipment.id + "-" + HelpersService.randomString();

        const {data}: Api.IResponse = await this.api3Service.request(Api.EMethod.Post,
            `/${this.state.section}/scan/outbound`, {
                shipment_id: this.shipment.id,
                value,
                package_id: this.selectedPackage.value,
                feed_id,

            }, {});

        this.spinnerService.hide();

        if (data) {
            switch (data.status) {
                case "error":
                    this.toastService.show(data.message, "error");
                    this.soundsService.textToSpeech(data.message);
                    this.addScan({
                        feed_id,
                        item: this.searchInput.value,
                        status: "error",
                        message: data.message,
                        quantity: 0,
                        type: "item"
                    });

                    break;
                case "pallet_found":
                    this.toastService.show(data.message, "success");
                    this.soundsService.textToSpeech(data.message);
                    this.addScan({
                        feed_id,
                        pallet: this.searchInput.value,
                        status: "pending",
                        quantity: 0,
                        type: "pallet"
                    });
                    break;

                case "box_found":
                    this.toastService.show(data.message, "success");
                    this.soundsService.textToSpeech(data.message);
                    this.addScan({
                        feed_id,
                        box: this.searchInput.value,
                        status: "pending",
                        quantity: 0,
                        type: "box"
                    });
                    break;

                case "serial_found":
                    this.toastService.show(data.message, "success");
                    this.soundsService.textToSpeech(data.message);
                    this.addScan({
                        feed_id,
                        serial: this.searchInput.value,
                        status: "pending",
                        quantity: 1,
                        type: "serial"
                    });
                    break;

                case "serial_found_missing_data":
                    this.outboundByOrderItem(data.data, feed_id, this.searchInput.value);
                    break;

                case "order_item_found":
                    this.outboundByOrderItem(data.data, feed_id);
                    break;
                default:
                    break;
            }
        }

        this.searchInput.reset();
        this.changeDetectorRef.markForCheck();
        this.setFocus();
    }

    /**
     * Create new package
     */
    public async newPackadge(): Promise<any> {
        const response: Modal.IResponse = await this.modalService.open(PackageFormComponent,
            {
                shipment: this.shipment,
                warehouse: this.shipment.warehouse,
                require_dimensions: false
            });

        if (response) {
            this.getPackages();
        }
    }

    public async editPackage(pack: any): Promise<any> {
        const response: Modal.IResponse = await this.modalService.open(PackageFormComponent, {
            package: pack,
            shipment: this.shipment,
            warehouse: this.shipment.warehouse,
            require_dimensions: false
        });

        if (response) {
            this.getPackages();
        }
    }

    public async deleteScans(ids: string[]): Promise<any> {
        if (!await this.confirm.confirm("Delete scanned item(s)?")) {
            return;
        }

        this.spinnerService.show();
        const {data}: Api.IResponse = await this.api3Service.request(Api.EMethod.Delete,
            `${this.state.section}/scan/outbound/${this.shipment.id}`, {ids});
        this.spinnerService.hide();

        this.checkedFeedItems = [];
        this.getScanBuffer();
    }

    public selectScan(id: string): void {
        if (this.checkedFeedItems.includes(id)) {
            return;
        }
        this.checkedFeedItems.push(id);
    }

    public deSelectScan(id: string): void {
        const index: number = this.checkedFeedItems.indexOf(id);
        this.checkedFeedItems.splice(index, 1);
        this.selectAll.setValue(false, {emitEvent: false});
    }

    public async exportPackList(type: string): Promise<any> {
        if (this.shipment.partner_id === 14) {
            await this.exportBoxPackList(type);
        } else {
            await this.exportUniversalPackList(type);
        }
    }

    public async completeScanning(): Promise<any> {
        const has_invalid = this.scanFeed.find((scan) => scan.status === "error");

        if (has_invalid) {
            if (!await this.confirm.confirm("Make transactions? All invalid scans will be ignored")) {
                return;
            }
        }

        this.spinnerService.show();

        const {code, message}: Api.IResponse = await this.api3Service.request(Api.EMethod.Post,
            `${this.state.section}/scan/outbound/${this.shipment.id}/convert`, {}, {});
        this.spinnerService.hide();

        if (code === 200) {
            this.toastService.show(message, "success");
            this.result.emit({
                action: "result",
                value: {
                    processScans: true
                },
                goToNextStep: true
            });
        }
    }

    public async printSticker(item: any): Promise<void> {
        this.modalService.open(OrderItemStickerComponent, {
            item,
            serials: [item.serial]
        });
    }

    public async openLocationCell(location_id: number): Promise<any> {
        if (!await this.confirm.confirm("Open locker cell?")) {
            return;
        }

        this.spinnerService.show();
        const {code, message}: Api.IResponse = await this.api3Service.get(
            `${this.state.section}/locations/${location_id}/open-cell`);
        this.spinnerService.hide();

        if (code === 200) {
            this.toastService.show(message, "success");
        }

    }

    public getPackageNameById(id: number): string {
        for (const p of this.packages) {
            if (p.id === id) {
                return p.name;
            }
        }
    }

    /**
     * Initialize step
     * @param data
     * @returns {Promise<any>}
     */
    public async init(data: Wizard.IData): Promise<any> {
        this.procedureType = data.procedureType;
        this.state = data.state;
        this.scannerKey = data.scannerKey;
        this.shipment = data.shipment;
        this.orderRef = data.orderRef;
        this.isViewOnly = data.isViewOnly;
        this.warehouse_slug = this.state.section_slug;
        this.changeDetectorRef.markForCheck();
        this.getShipment();
        this.getItems();
        this.getPackages();
        this.getScanBuffer();
        this.getWarehouse();

        if (this.selectedPackage.value) {
            this.setFocus();
        }
        if (this.isViewOnly) {
            this.searchInput.disable();
        }

        this.result.emit({
            action: "result",
            value: true
        });

        this.selectAll.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value: boolean) => {
            for (const feed_item of this.scanFeed) {
                if (value) {
                    if (this.showOnlyFailedScans.value && feed_item.status !== "error") {
                        continue;
                    }
                    this.selectScan(feed_item.feed_id);
                } else {
                    this.deSelectScan(feed_item.feed_id);
                }
            }
            this.changeDetectorRef.markForCheck();
        });
    }

    public ngOnDestroy(): void {
        super.ngOnDestroy();
        if (this.shipment) {
            this.pusherService.echo.leave("scan-feed-" + this.shipment.id);
        }
    }

}
